import { render, staticRenderFns } from "./AddNewChat.vue?vue&type=template&id=7bfdc3e2&scoped=true"
import script from "./AddNewChat.vue?vue&type=script&lang=js"
export * from "./AddNewChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfdc3e2",
  null
  
)

export default component.exports